import { Link } from 'react-router-dom'
import Navbar from '../components/Navbar'
import Footer from '../components/Footer'

/**
 * Stripe Checkout cancel landing page.
 *
 * Stripe redirects here when the user backs out of the hosted checkout
 * (configured via STRIPE_CANCEL_URL). Cancelling is not an error, so the tone
 * is neutral and reassuring. No webhook fires for an abandoned checkout, so
 * there is nothing to undo here.
 */
export default function Cancel() {
    return (
        <div className="min-h-screen flex flex-col" style={{ backgroundColor: '#FAFAFA' }}>
            <Navbar />

            <div className="flex-1 w-full px-4 sm:px-6 py-16 sm:py-24 flex items-center justify-center">
                <div className="w-full max-w-md">
                    <div className="bg-white rounded-xl text-center px-8 sm:px-10 py-10"
                        style={{ border: '1px solid rgba(209,213,219,0.6)', boxShadow: '0 1px 3px rgba(0,0,0,0.04)' }}>

                        {/* Neutral grey × — matches the muted "what never happens" icons, not an error red */}
                        <div className="mx-auto mb-7 flex h-14 w-14 items-center justify-center rounded-full bg-gray-100">
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                                stroke="#9CA3AF" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                                <line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" />
                            </svg>
                        </div>

                        <p className="text-[10px] font-mono font-bold tracking-[0.28em] uppercase text-gray-400 mb-4">
                            Checkout cancelled
                        </p>

                        <h1 className="font-sans font-bold text-3xl text-gray-950 tracking-tight mb-3 leading-tight">
                            No charge was made
                        </h1>

                        <p className="text-base font-body text-gray-600 leading-relaxed mb-8">
                            Nothing changed on your account. You can choose a plan whenever
                            you&rsquo;re ready.
                        </p>

                        <div className="flex flex-col gap-3">
                            <Link to="/pricing" className="btn-primary block text-center">
                                Back to plans
                            </Link>
                            <Link to="/dashboard"
                                className="block text-center rounded px-6 py-3 font-body font-semibold text-gray-600 border border-gray-300 transition-colors duration-200 hover:border-brand-amber hover:text-brand-amber">
                                Return to dashboard
                            </Link>
                        </div>
                    </div>
                </div>
            </div>

            <Footer />
        </div>
    )
}